<template>
<CRow>
<CDataTable
    class="col-12 px-0"
    :items="Object.values(conversions)"
    :fields="$dataTableFieldsMaker(fields)"
    hover
    :pagination="{...pagination, change: fetchConversions}"
    addTableClasses="bg-white"
>
    <template #storeName="{item}">
        <td>
            {{ item.store.name }}
        </td>
    </template>

    <template #type="{item}">
        <td>
            {{ conversionTypeStr(item.type) }}
        </td>
    </template>

    <template #user="{item}">
        <td>
            {{ item.user ? item.user.full_name : '' }}
        </td>
    </template>

    <template #wage="{item}">
        <td class="ltr font-weight-bold">
            {{ item.wage ? $numberWithCommas(item.wage) : '' }}
        </td>
    </template>

    <template #link="{item}">
        <td>
            <span v-if="item.link && item.link.title" :title="item.link.title">
                {{ item.link.title.length > 12 ? item.link.title.substring(0, 12)+'...' : item.link.title }}
            </span>
            <span v-else>
                {{ $t('undefined') }}
            </span>
        </td>
    </template>

    <template #createdAt="{item}">
        <td>
            {{ $moment(item.created_at).format('LL') }}
        </td>
    </template>

    <template #checkedOutAt="{item}">
        <td>
            {{ item.checked_out_at ? $moment(item.checked_out_at).format('LL') : '-' }}
        </td>
    </template>

    <template #amount="{item}">
        <td class="font-weight-bold"
            v-if="item.type == ConversionType.LEAD"
        >
            <span
                class="badge badge-affili-eggplant text-center"
            >{{ $t('conversion.types.lead') }}</span>
        </td>
        <td class="ltr font-weight-bold"
            v-else
        >
            {{ item.amount ? $numberWithCommas(item.amount) : '0' }}
        </td>
    </template>

    <template #statutoryDeductions="{item}">
        <td class="ltr font-weight-bold">
            {{ $numberWithCommas(item.statutory_deductions) }}
        </td>
    </template>

    <template #commissionAmount="{item}">
        <td class="ltr font-weight-bold">
            {{ $numberWithCommas(item.commission_amount) }}
        </td>
    </template>

    <template #externalId="{item}">
        <td>
            {{ item.external_id || '' }}
        </td>
    </template>

    <template #status="{item}">
        <td>
            <span :class="'badge badge-'+conversionStatusColor(item.status)">
                {{ conversionStatusStr(item.status) }}
                <span v-if="item.is_closed">(قطعی)</span>
            </span>
        </td>
    </template>

    <template #actions="{item}">
        <td>
            <CLink
                v-if="$policy('conversion', item).edit"
                :disabled="Boolean(item.is_closed)"
                :class="item.is_closed ? 'text-muted outline-none' : ''"
                :to="{name: 'conversions.edit', params: {id: item.id}}">
                <FaIcon icon="edit" />
            </CLink>
            <FaIcon v-if="item.products && item.products.length > 0"  @click="modal = {show: true, item: item.products}" :icon="['fas', 'shopping-basket']" class="mfs-1 text-info cursor-pointer" />
            <FaIcon v-if="item.type == ConversionType.LEAD && item.meta && Object.keys(item.meta).length > 0"  @click="metaModal = {show: true, item: item.meta}" icon="bullseye" class="mfs-1 text-info cursor-pointer" />
        </td>
    </template>
</CDataTable>
<CModal :show.sync="modal.show" size="lg">
    <template #header-wrapper>
        <div></div>
    </template>

    <CDataTable
        v-if="modal.item"
        class="col-12 px-0"
        :items="modal.item"
        :fields="$dataTableFieldsMaker(productsFields)"
    >
        <template #pid="{item}">
            <td>
                {{ item.pid || '-' }}
            </td>
        </template>

        <template #name="{item}">
            <td>
                {{ item.sku || item.name }}
            </td>
        </template>

        <template #unitPrice="{item}">
            <td class="ltr">
                {{ item.unit_price ? $numberWithCommas(item.unit_price) : '' }}
            </td>
        </template>

        <template #quantity="{item}">
            <td>
                {{ item.quantity }}
            </td>
        </template>

        <template #totalPrice="{item}">
            <td class="ltr">
                {{ item.total_price ? $numberWithCommas(item.total_price) : '' }}
            </td>
        </template>
    </CDataTable>

    <template #footer-wrapper>
        <div></div>
    </template>
</CModal>
<CModal :show.sync="metaModal.show" size="lg">
    <template #header-wrapper>
        <div></div>
    </template>

    <CDataTable
        v-if="metaModal.item"
        class="col-12 px-0"
        :items="[metaModal.item]"
        :fields="$dataTableFieldsMaker(Object.keys(metaModal.item))"
    >
    </CDataTable>

    <template #footer-wrapper>
        <div></div>
    </template>
</CModal>
</CRow>
</template>

<script>
import fields, { productsFields } from './fields'
import { ConversionType } from '@/constants'
import { mapActions, mapGetters } from 'vuex'
import { conversionStatusColor, conversionStatusStr, conversionTypeStr } from './methods'

export default {
    name: 'Table',

    props: {
        params: {}
    },

    data() {
        return {
            fields,
            productsFields,
            ConversionType,
            modal: {
                item: [],
                show: false
            },
            metaModal: {
                item: [],
                show: false
            }
        }
    },

    computed: {
        ...mapGetters({
            conversions: 'conversion/conversions',
            pagination: 'conversion/pagination',
            filterMeFields: 'filterMeComponent/filterMeFields',
        }),
    },

    methods: {
        ...mapActions({
            fetch: 'conversion/fetch'
        }),
        conversionStatusColor,
        conversionStatusStr,
        conversionTypeStr,
        fetchConversions(activePage = 1) {
            this.fetch({
                page: activePage,
                ...this.params,
                ...this.filterMeFields
            })
        },
    }
}
</script>